/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get } from 'lodash';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import HtmlEditor from 'shared/ui/components/editors/html/HtmlEditor.vue';
import LanguagePicker from 'shared/ui/components/form-components/pickers/LanguagePicker.vue';
import RequirementsPicker from 'shared/ui/components/form-components/pickers/RequirementsPicker.vue';
import FileDropper from 'shared/ui/components/form-components/pickers/FileDropper.vue';
import RadioButtons from 'shared/ui/components/form-components/RadioButtons.vue';

const __vue_script__ = {
    name: 'LegalDocumentForm',

    components: { BaseInput, BaseSelect, HtmlEditor, LanguagePicker, RequirementsPicker, FileDropper, RadioButtons },

    props: {
        legalDoc: {
            type: Object,
            default: () => ({
                requirements: {},
                text: {},
                title: {},
                url: {},
            })
        },

        orgId: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            languages: ['en'],
            languagesWithLabels: this.$utils.locales.getLocaleLabels(['en']),
            currentLang: { value: 'en', label: 'English' },
            currentLangDetails: {
                title: '',
                text: '',
                url: '',
                requirements: [],
            },
            doc: {},
            docType: 'text',
            docTypeOptions: [
                { value: 'text', label: this.$t('legal_documents.editor.doc_type.text') },
                { value: 'link', label: this.$t('legal_documents.editor.doc_type.link') },
            ],
        };
    },

    watch: {
        legalDoc: {
            immediate: true,
            handler() {
                this.onPropChange();
            }
        },
    },

    methods: {
        onPropChange() {
            this.doc = this.legalDoc;
            this.languages = this.$utils.locales.filterValidLocales(
                this.$services.legal.getLegalDocLanguages(this.legalDoc)
            );
            if (!this.languages.length) { this.languages = ['en']; }

            this.languagesWithLabels = this.$utils.locales.getLocaleLabels(this.languages);
            if (this.languagesWithLabels[0]) {
                this.currentLang = this.languagesWithLabels[0];
                this.setCurrentLangDetails(this.languagesWithLabels[0].value);
            }
        },

        /** @param {string[]} langs */
        onLangChange(langs) {
            this.languagesWithLabels = this.$utils.locales.getLocaleLabels(langs);
            const last = this.languagesWithLabels.slice(-1)[0];
            if (last) {
                this.currentLang = last;
                this.setCurrentLangDetails(last.value);
            }
        },

        /** @param {{ value: string, label: string }} lang */
        onCurrentLangChange(lang) {
            this.setCurrentLangDetails(lang.value);
        },

        /** @param {FileList} filelist */
        async onFileDropped(filelist) {
            const file = filelist[0];
            if (!file) { return; }

            try {
                const { url } = await this.$services.publicAssets.uploadLegalAsset(this.orgId, file, file.name);
                this.currentLangDetails.url = url;
                this.onDetailChange();
            } catch (error) {
                console.error('[LegalDocumentForm] Could not upload assets', error.message || error);
                this.$notify({
                    group: 'flashes',
                    title: this.$t('general.error_occurred'),
                    text: this.$i18n.t('legal_documents.editor.asset_upload_failed').toString(),
                    type: 'error'
                });
            }
        },

        onDetailChange() {
            //  as the other docType is hidden we need to set the value of the other to empty to not save things we do not see
            if (this.docType === 'text') {
                this.currentLangDetails.url = '';
            } else {
                this.currentLangDetails.text = '';
            }

            const lang = this.currentLang.value;
            this.setDocValue('title', lang);
            this.setDocValue('text', lang);
            this.setDocValue('url', lang);
            this.setDocValue('requirements', lang);
            this.$emit('change', this.doc);
        },

        /** @param {string} lang */
        setCurrentLangDetails(lang) {
            this.currentLangDetails = {
                title: get(this.doc, ['title', lang], ''),
                text: get(this.doc, ['text', lang], ''),
                url: get(this.doc, ['url', lang], ''),
                requirements: get(this.doc, ['requirements', lang], []),
            };
            this.docType = this.currentLangDetails.url.trim() === '' ? 'text' : 'link';
            this.onDetailChange();
        },

        /**
         * @param {string} key
         * @param {string} lang
         */
        setDocValue(key, lang) {
            const allLangs = get(this.doc, key) || {};
            allLangs[lang] = get(this.currentLangDetails, key);
            this.doc[key] = allLangs;
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legal-documents-form"},[_c('fieldset',[_c('language-picker',{attrs:{"label":_vm.$t('general_settings.section_titles.languages'),"name":"languages"},on:{"input":_vm.onLangChange},model:{value:(_vm.languages),callback:function ($$v) {_vm.languages=$$v},expression:"languages"}})],1),_c('hr'),_c('fieldset',[_c('div',{staticClass:"form-groups"},[_c('div',{staticClass:"form-group"}),_c('base-select',{ref:"currentLang",staticClass:"current-lang",attrs:{"name":"currentLang","options":_vm.languagesWithLabels,"options-label":"label","allow-blank":false},on:{"input":_vm.onCurrentLangChange},model:{value:(_vm.currentLang),callback:function ($$v) {_vm.currentLang=$$v},expression:"currentLang"}})],1),_c('radio-buttons',{attrs:{"name":"docType","options":_vm.docTypeOptions,"inline":true},model:{value:(_vm.docType),callback:function ($$v) {_vm.docType=$$v},expression:"docType"}})],1),_c('p',{staticClass:"form-group"},[_vm._v(_vm._s(_vm.$t(("legal_documents.editor.doc_type_explanation." + _vm.docType))))]),_c('validation-observer',{ref:"form",attrs:{"tag":"form"}},[_c('validation-provider',{attrs:{"slim":true,"name":"title"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"label":_vm.$t('legal_documents.editor.title'),"name":"title"},on:{"input":_vm.onDetailChange},model:{value:(_vm.currentLangDetails.title),callback:function ($$v) {_vm.$set(_vm.currentLangDetails, "title", $$v)},expression:"currentLangDetails.title"}})]}}])}),(_vm.docType === 'text')?_c('validation-provider',{attrs:{"slim":true,"name":"text"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('html-editor',{attrs:{"label":_vm.$t('legal_documents.editor.text'),"name":"text","enable-custom-bstg-links":false,"formats":false,"extras":false,"lists":false,"blockquote":false,"errors":errors},on:{"input":_vm.onDetailChange},model:{value:(_vm.currentLangDetails.text),callback:function ($$v) {_vm.$set(_vm.currentLangDetails, "text", $$v)},expression:"currentLangDetails.text"}})]}}],null,false,832854719)}):_vm._e(),(_vm.docType === 'link')?_c('validation-provider',{attrs:{"slim":true,"name":"url"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"label":_vm.$t('legal_documents.editor.url'),"name":"url","errors":errors},on:{"input":_vm.onDetailChange},model:{value:(_vm.currentLangDetails.url),callback:function ($$v) {_vm.$set(_vm.currentLangDetails, "url", $$v)},expression:"currentLangDetails.url"}})]}}],null,false,2973437576)}):_vm._e(),(_vm.currentLangDetails.url === '' && _vm.docType === 'link')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('legal_documents.editor.upload')))]),_c('file-dropper',{attrs:{"multiple":false,"supported-mimes":['application/pdf']},on:{"input":_vm.onFileDropped}})],1):_vm._e(),_c('requirements-picker',{attrs:{"label":_vm.$t('legal_documents.editor.requirements'),"name":"requirements"},on:{"input":_vm.onDetailChange},model:{value:(_vm.currentLangDetails.requirements),callback:function ($$v) {_vm.$set(_vm.currentLangDetails, "requirements", $$v)},expression:"currentLangDetails.requirements"}})],1)],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LegalDocumentForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__